import { ModuleWithProviders } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { CalendarComponent } from "../common/modules/shared/components/calendar/CalendarComponent";
import { NavigateComponent } from "./navigate-page/NavigateComponent";

const appRoutes: Routes = [
  { path: "", redirectTo: "login", pathMatch: "full" },
  {
    path: "navigate",
    component: NavigateComponent,
  },
  { path: "calendars", component: CalendarComponent },
];

export const appRoutingProviders: any[] = [];

export const routing: ModuleWithProviders = RouterModule.forRoot(appRoutes);



// WEBPACK FOOTER //
// ./src/auth/AppRouting.ts